import React from "react";

export function BonsaiMonogram({ size = 32, className = "" }) {
  return (
    <svg viewBox="0 0 300 300" width={size} height={size} className={className} aria-hidden="true">
      <path fill="#11B767" d="M134,294.2c0.5,0.1,1,0.1,1.5,0.2c0.5,0.1,1,0.1,1.5,0.1c1.9,0.2,3.9,0.3,5.8,0.4c1.8,0.1,3.5,0.1,5.3,0.1c0.6,0,1.3,0,1.9,0c53.9,0,100.8-29.7,125.3-73.6l-250.7-0.1C46.7,260.9,86.9,289,134,294.2z" />
      <path fill="#01A2F2" d="M252.4,161.2c-7.1-0.6-13.4,4.5-14.1,11.6c-0.1,0.9-0.1,1.8,0,2.7l-84.9,29.4v-51.3l37-12.8c3.9,6,12,7.7,18,3.7c6-3.9,7.7-12,3.7-18c-3.9-6-12-7.7-18-3.7c-3.3,2.2-5.4,5.7-5.8,9.7c-0.1,0.7-0.1,1.5,0,2.2l-37.3,12.9L112.5,133v-17.7c6.9-1.8,11.1-8.9,9.3-15.8c-1.8-6.9-8.9-11.1-15.8-9.3c-6.9,1.8-11.1,8.9-9.3,15.8c1.2,4.6,4.7,8.1,9.3,9.3v22.1l2.1,0.8l0,0l38.7,14.8v68.4h6.5v-9.5l87.2-30.2c2.2,3.1,5.6,5,9.4,5.4c7.1,0.6,13.4-4.6,14.1-11.8c0.6-7.1-4.6-13.4-11.8-14.1L252.4,161.2z" />
      <path fill="#ffffff" d="M150,277.7c-5-0.1-8.9-4.2-8.8-9.2c0-0.1,0-0.1,0-0.2v-51.6h17.2v51.6c0.2,5-3.6,9.1-8.6,9.4c0,0,0,0-0.1,0" />
      <path fill="#11B767" d="M123.6,25.9c8.9-1.7,18.2-2.6,27.6-2.6c5,0,10,0.3,14.9,0.8c48.9,4.2,91.7,30.3,118.4,68.3C262.2,40.9,210.9,4.8,151.2,4.8c-62,0-114.8,38.8-135.7,93.5C39.4,60.9,78.2,34,123.6,25.9z" />
    </svg>
  );
}

export function BonsaiLogo({ size = 30, className = "", dark = false }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <BonsaiMonogram size={size} />
      <span
        className="font-extrabold tracking-tight"
        style={{ fontSize: size * 0.72, color: dark ? "#fff" : "#293E46" }}
      >
        bonsai
      </span>
    </div>
  );
}
